/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Step2_DescInputs */

const en_serve_step2_desc = /** @type {(inputs: Serve_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Terminal app (Mac) or PowerShell (Windows), paste the first command, then the second one and sign in with your Claude account. Have a ChatGPT subscription instead? Install Codex the same way.`)
};

const id_serve_step2_desc = /** @type {(inputs: Serve_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka aplikasi Terminal (Mac) atau PowerShell (Windows), tempel perintah pertama, lalu perintah kedua dan masuk dengan akun Claude-mu. Punya langganan ChatGPT? Pasang Codex dengan cara yang sama.`)
};

/**
* | output |
* | --- |
* | "Open the Terminal app (Mac) or PowerShell (Windows), paste the first command, then the second one and sign in with your Claude account. Have a ChatGPT subscr..." |
*
* @param {Serve_Step2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_step2_desc = /** @type {((inputs?: Serve_Step2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Step2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_step2_desc(inputs)
	return en_serve_step2_desc(inputs)
});